import { useTheme } from "../context/ThemeContext";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const { theme } = useTheme();

  return (
    <footer className="site-footer" data-theme={theme}>
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-brand">
            <h3 className="footer-heading">EBI Education</h3>
            <p className="footer-tagline">Bright Minds, Brighter Futures <br />Harman Dhiman</p>
          
          </div>

          <div className="footer-links-grid">
            <div className="footer-section">
              <h4>Quick Links</h4>
              <div className="footer-links">
                <Link to="/">Home</Link>
                <Link to="/courses">Courses</Link>
                <Link to="/notes">Notes</Link>
                <Link to="/contact">Contact</Link>
              </div>
            </div>

            <div className="footer-section">
              <h4>Contact</h4>
              <div className="footer-contact">
                <p>📍 Bahadargarh</p>
                <p>📞 +91 98140 81881</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} EBI Education. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;